import { ContentBlockBase } from './ContentBlock';
import { ContentBlockBody } from './ContentBlock.Body/ContentBlock.Body';
import { ContentBlockHeader } from './ContentBlock.Header/ContentBlock.Header';
export var ContentBlock = Object.assign(ContentBlockBase, {
  Header: ContentBlockHeader,
  Body: ContentBlockBody
});